var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container grid grid-cols-12 row-gap-10 md:col-gap-10"},[(_vm.loading)?[_c('div',{staticClass:"h-40 col-span-12 flex flex-col justify-center items-center"},[_c('p',[_vm._v("Confirming that the booking has been scheduled.")]),_c('loading-icon',{staticClass:"w-10 h-10 text-pink-500"})],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }